/*----------------------------------
- DEPENDANCES
----------------------------------*/

import { FREE_TRIAL_CONVERSION_BILLING_COPY, FREE_TRIAL_CONVERSION_PLAN_COPY } from '@/common/libs/freeTrial';

/*----------------------------------
- CATALOG
----------------------------------*/

/** What a locked part of the app says about itself to someone on the free trial: what it is, and what Pro opens. */
export const PRO_UNLOCK_FEATURES = {
    campaigns: {
        title: 'Campaigns come with Pro',
        description: 'Reach the people you found with a guided sequence on LinkedIn and email, written for your goal.',
        bullets: [
            'Message templates written for each campaign type and audience',
            'Sequences across LinkedIn and email, sent at the right pace',
            'Connect your own LinkedIn account and mailbox',
            'Replies and results in one place',
        ],
    },
    networkScan: {
        title: 'The full Network Scanner comes with Pro',
        description: 'Scan your whole network for companies that are hiring, and keep it up to date.',
        bullets: [
            'Full Network Scanner access with LinkedIn connected',
            'Import your entire network, not just a sample',
            'Automatic updates, so new opportunities find you',
            'Everything you prepared during the trial stays available',
        ],
    },
    generic: {
        title: 'This is part of Pro',
        description: `This feature opens with the ${FREE_TRIAL_CONVERSION_PLAN_COPY}.`,
        bullets: [
            'Full Network Scanner access with LinkedIn connected',
            'CRM BizDev search, campaigns and your prepared prospecting workflow',
            'Full network import and automatic updates',
        ],
    },
} as const satisfies Record<string, { title: string; description: string; bullets: readonly string[] }>;

export type ProUnlockFeature = keyof typeof PRO_UNLOCK_FEATURES;

export const PRO_UNLOCK_BILLING_COPY = FREE_TRIAL_CONVERSION_BILLING_COPY;
export const PRO_UNLOCK_PLAN_COPY = FREE_TRIAL_CONVERSION_PLAN_COPY;

/*----------------------------------
- HELPERS
----------------------------------*/

/** Which locked part a plan-gate error is about: the server names the feature it protects. */
export const proUnlockFeatureFor = (serverFeature: string | null | undefined): ProUnlockFeature => {
    if (serverFeature === 'prospector') return 'campaigns';
    if (serverFeature === 'hasCrmNetworkScan') return 'networkScan';
    return 'generic';
};
